<template>
  <div>
    <TopBar title="Commandes" :cart="false"/>
    <div class="page-content">
      <div class="container">
        <div v-if="loading" class="dz-spinner color-spinner">
          <div class="spinner-border spinner-sm me-2 mb-2 text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div v-show="!loading" class="dz-tab bg-white">
          <div class="tab-slide-effect">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="tab-active-indicator"></li>
              <li class="nav-item active" role="presentation">
                <button class="nav-link active" id="home-tab" data-bs-toggle="tab" data-bs-target="#home-tab-pane" type="button" role="tab" aria-controls="home-tab-pane" aria-selected="true">En attente</button>
              </li>
              <li class="nav-item" role="presentation">
                <button class="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile-tab-pane" type="button" role="tab" aria-controls="profile-tab-pane" aria-selected="false">Validé</button>
              </li>
            </ul>
          </div>
          <div class="tab-content" id="myTabContent1">
            <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
             <Order v-for="(createdOrder, index) in created" :total="created?.length" :order="createdOrder" :key="createdOrder.id" :index="index"/>
              <p v-if="created.length == 0" class="mb-0"> Aucune commande en attente de validation</p>
            </div>
            <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">
              <Order v-for="(validatedOrder, index) in validated" :order="validatedOrder" :key="validatedOrder.id" :index="index"/>
              <p v-if="validated.length == 0" class="mb-0"> Aucune commande validée</p>
            </div>
          </div>
        </div>
      </div>
      <br> <br> <br> <br>
    </div>
  </div>
</template>

<script setup>

import {useStore} from "vuex";
import {computed, nextTick, onMounted, onUpdated, ref} from "vue";
import TopBar from "@/views/master/layouts/partials/TopBar";
import Order from "@/components/order";

const store = useStore()
const loading = ref(false)

onMounted(() => {
  handleTabSlide()
  loading.value = true
  store.dispatch('order/loadOrders').finally(() => {
    loading.value = false
  })

})

onUpdated(() => {
  nextTick(() =>  {
    handleTabSlide()
  })
})

const orders = computed(() => store.getters['order/getOrders'])
const created = computed(() => orders.value?.filter(order => order.status == "CREATED"))
const validated = computed(() => orders.value?.filter(order => order.status == "VALIDATED"))

function handleTabSlide() {
  if($('.tab-slide-effect').length > 0)
  {
    let a =  $('.tab-slide-effect li.active').width();
    let b =  $('.tab-slide-effect li.active').position().left;

    $('.tab-active-indicator').css({'width' : a+'px','transform': 'translateX('+b+'px)'});
    $('.tab-slide-effect li').on('click',function(){
      let tabItem = $(this).parent().find('li');
      $(tabItem).removeClass('active');
      $(this).addClass('active');
      let x = $(this).width();
      let y = $(this).position().left;
      let indicator = $(this).parent().find('.tab-active-indicator');
      $(indicator).css({'width' : x,'transform': 'translateX('+y+'px)'});
    })
  }
}

</script>